import Page from 'components/layout/Page';
import Faqs from 'components/marketingSite/shared/Faqs';
import { FaqProps } from 'components/marketingSite/shared/FaqsItem';
import { useI18n } from 'hooks/useI18n';
import { StyledFaqs } from './HPCComponent.styled';
import HPCAddProcess from './sections/addProcess/HPCAddProcess';
import HPCCompanies from './sections/companies/HPCCompanies';
import HPCComparison from './sections/comparison/HPCComparison';
import HPCHero from './sections/hero/HPCHero';
import HPCTips from './sections/tips/HPCTips';

type ContentProps = {
  content?: any[];
  tips?: any[];
  faqs?: any[];
};

const HPCComponent: React.FC<ContentProps> = ({ content, tips, faqs }) => {
  const { t } = useI18n('hiring-process-comparison');
  const faqsArray: FaqProps[] =
    faqs
      ?.sort((a, b) => a.attributes.order - b.attributes.order)
      .map((faq) => ({
        question: faq.attributes.question,
        answer: faq.attributes.answer
      })) || [];
  return (
    <Page pageVariant="light" hasScrollTop>
      <HPCHero />
      <HPCCompanies content={content} />
      <HPCComparison content={content} />
      <HPCAddProcess />
      <HPCTips tips={tips} />
      <StyledFaqs id="faqs">
        <Faqs
          faqs={faqsArray}
          title={t('hiring-process-comparison.faqs.title')}
        />
      </StyledFaqs>
    </Page>
  );
};

export default HPCComponent;
